<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <div class="round"> <img id="logo-dialog" src="../assets/logo.png" alt=""></div>
        <section class="modal-body">
          <slot name="body">
            <v-form id="form" ref="mailForm" @submit.prevent="sendPrice">
              <v-container grid-list-lg>
                <v-layout row wrap>

                  <!-- Naam -->
                  <v-flex xs12>
                    <v-text-field v-model="mail.naam" :rules="nameRules" outline placeholder="Naam klant"></v-text-field>
                  </v-flex>

                  <!-- Email -->
                  <v-flex xs12>
                    <v-text-field v-model="mail.email" outline placeholder="naam@emailadres.com"></v-text-field>
                  </v-flex>

                  <!-- Telefoon nummer -->
                  <v-flex xs12>
                    <v-text-field v-model="mail.telefoon" outline placeholder="06-00000000"></v-text-field>
                  </v-flex>

                  <v-flex xs12 text-xs-right>
                    <v-btn class="price-btn text-none" color="primary" type="submit" outline>Verstuur email<v-icon
                        class="right-icon" right>far fa-chevron-right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </slot>
        </section>
      </div>
      <span class="btn-close" @click="close">
        <img src="../assets/ui-elements/close-btn.png" alt=""></span>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'modal',
    props: {
      parentData: Object
    },
    data(){
      return {
        nameRules: [name => !!name || 'Naam is verplicht'],
        emailRules: [mail => !!mail || 'Email is verplicht'],
       mail: {
          naam: '',
        email: '',
        telefoon: ''
       }

      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      sendPrice(){
        if(this.$refs.mailForm.validate()){
                this.$emit('sendMail', this.mail);
              //  console.log(this.name)
        }
      },
    },
  };
</script>


<style scoped>
  #logo-dialog {
    position: relative;
    top: 5px;
    left: 1.5em;
  }

  #form {
    padding-right: 2em !important;
    padding-left: 2em !important;
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    /* overflow-x: auto; */
    display: flex;
    flex-direction: column;
    width: 60%;;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }


  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    border: none;
    font-size: 150% !important;
    position: relative;
    top: -10.3em;
    left: 0.5em;
    cursor: pointer;
    font-weight: bold;
    color: #fff !important;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }

  .round {
    background-color: white;
    border-radius: 70%;
    width: 105px;
    display: inline-block;
    position: relative;
    left: 35em;
    top: -1em;

  }

  .price-btn {
    margin: 0 !important;
    border-radius: 4px;
  }

  .right-icon {
    font-size: 20px;
  }

  @media screen and (max-width: 1440px) {
    .round {
      top: -1em;
      left: 27em;
    }

    .btn-close {
      top: -11.5em;
    }
  }


  @media screen and (max-width: 1024px) {
    .round {
      top: -1em;
      left: 18em;
    }

    .btn-close {
      top: -10.5em;
    }

  }


  @media screen and (max-width: 768px) {
    .round {
      top: -1em;
      left: 13em;
    }
  }

  @media screen and (max-width: 425px) {
    .round {
      top: -1em;
      left: 6em;
    }

    .modal {
      margin-left: 2em;
    }

    .right-icon {
      display: none;
    }

    .price-btn {
      width: 100%;
    }

    #form {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }
  }


  @media screen and (max-width: 375px) {
    .round {
      top: -1em;
      left: 4.5em;
    }

    .modal {
      margin-left: 2em;
    }

    .price-btn {

      margin: 0 !important;
    }

    .right-icon {
      display: none;
    }
  }

  @media screen and (max-width: 320px) {
    .round {
      top: -1em;
      left: 3.5em;
    }

    .modal {
      margin-left: 2em;
    }

    .btn-close {
      top: -10em;
    }

    .price-btn {
      /* border-radius: 4px; */
      height: 30px !important;
      width: 140px !important;
      margin: 0 !important;
    }

    .right-icon {
      display: none;
    }
  }
</style>